import { render, staticRenderFns } from "./SoftwareSolutions.vue?vue&type=template&id=026dcf7a&scoped=true&"
import script from "./SoftwareSolutions.vue?vue&type=script&lang=js&"
export * from "./SoftwareSolutions.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareSolutions.vue?vue&type=style&index=0&id=026dcf7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026dcf7a",
  null
  
)

export default component.exports